import React from 'react';

const ModuleCard = ({ module, getModuleProgress, thumbnail, onSelect }) => {
  const moduleProgress = getModuleProgress(module.id);

  // Função para formatar o total de segundos em uma string legível
  const formatTotalSeconds = (totalSeconds) => {
    if (totalSeconds === 0) return null;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    if (hours > 0) return `${hours}h ${minutes.toString().padStart(2, '0')}min`;
    if (minutes > 0) return `${minutes}min`;
    return null; // Não mostra se for menos de 1 minuto
  };

  // Soma a duração de todas as aulas (que está em segundos) para obter a duração total do módulo.
  const totalDurationInSeconds = (module.lessons || []).reduce((acc, lesson) => acc + (lesson.durationSeconds || 0), 0);
  const totalDurationFormatted = formatTotalSeconds(totalDurationInSeconds);

  return (
    <div className={`module-card ${moduleProgress === 100 ? 'completed' : ''}`}>
      <div className="module-thumbnail">
        {thumbnail ? (
          <img src={thumbnail} alt={`Thumbnail para ${module.title}`} className="thumbnail-image" />
        ) : (
          <div className="thumbnail-placeholder">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" />
              <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" />
            </svg>
            <span>Módulo</span>
          </div>
        )}
        <div className="progress-overlay">
          <div
            className="progress-bar"
            style={{ width: `${moduleProgress}%` }}
          ></div>
        </div>
      </div>
      
      <div className="module-content">
        <h3 className="module-title">{module.title}</h3>
        
        <div className="module-meta">
          <span className="lesson-count">
            {(module.lessons || []).length} aulas
          </span>
          {totalDurationFormatted && (
            <>
              <span className="meta-separator">·</span>
              <span className="duration-count">{totalDurationFormatted}</span>
            </>
          )}
        </div>

        <div className="module-progress-info">
          <div className="progress-circle-compact">
            <svg width="56" height="56" viewBox="0 0 56 56" className="progress-circle-svg">
              <circle cx="28" cy="28" r="24" fill="none" stroke="#e2e8f0" strokeWidth="3" />
              <circle
                cx="28" cy="28" r="24" fill="none" stroke={moduleProgress === 100 ? '#10b981' : '#3b82f6'} strokeWidth="3"
                strokeDasharray={`${150.8 * (moduleProgress / 100)} 150.8`}
                transform="rotate(-90 28 28)"
                strokeLinecap="round"
                style={{ transition: 'stroke-dasharray 0.5s ease' }}
              />
            </svg>
            <span className={`progress-percentage ${moduleProgress === 100 ? 'completed' : ''}`}>
              {moduleProgress}%
            </span>
          </div>
        </div>
      </div>

      <div className="module-actions">
        {moduleProgress === 100 ? (
          <>
            <button className="btn btn-success" disabled>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20,6 9,17 4,12" /></svg>
              Concluído
            </button>
            <button onClick={onSelect} className="btn btn-secondary view-lessons-btn">
              Ver aulas
            </button>
          </>
        ) : (
          <button onClick={onSelect} className="btn btn-primary">
            {moduleProgress > 0 ? 'Continuar' : 'Começar'}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12,5 19,12 12,19" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default ModuleCard;